import axios from 'axios';

export default async function removeResponsibles({
  accessToken,
  companyId,
  responsible_ids,
  setTokenLikeExpired,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANIES_API_URL}/responsible/remove/${companyId}`,
      { responsible_ids },
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  }
}
